import { useState } from 'react'
import { KanbanBoard } from './KanbanBoard'
import { SpecsTree } from './SpecsTree'
import { Shard } from '../types/shard'
import { Worker } from '../hooks/useWorkers'

type BoardSubView = 'board' | 'specs'

interface BoardViewProps {
  shards: Shard[]
  workers: Worker[]
  onShardClick: (shard: Shard) => void
  onWorkerClick: (worker: Worker) => void
}

export function BoardView({ shards, workers, onShardClick, onWorkerClick }: BoardViewProps) {
  const [subView, setSubView] = useState<BoardSubView>('board')

  return (
    <div className="flex flex-col h-full min-h-0">
      {/* Sub-toggle */}
      <div className="flex items-center gap-1 px-4 py-1.5 bg-cosmic-void/50 border-b border-cosmic-border/50">
        <button
          onClick={() => setSubView('board')}
          className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
            subView === 'board'
              ? 'bg-cosmic-surface text-white'
              : 'text-gray-500 hover:text-gray-300'
          }`}
        >
          Board
        </button>
        <button
          onClick={() => setSubView('specs')}
          className={`px-3 py-1 rounded text-xs font-medium transition-colors ${
            subView === 'specs'
              ? 'bg-cosmic-surface text-white'
              : 'text-gray-500 hover:text-gray-300'
          }`}
        >
          Specs
        </button>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto min-h-0">
        {subView === 'board' ? (
          <KanbanBoard shards={shards} onCardClick={onShardClick} workers={workers} />
        ) : (
          <SpecsTree
            shards={shards}
            workers={workers}
            onShardClick={onShardClick}
            onWorkerClick={onWorkerClick}
          />
        )}
      </div>
    </div>
  )
}
